import { Box, IconButton } from "@mui/material";
import { DotLegalDialog, DotLegalHeader, useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { CreateApiKeyResultViewModel } from "../ApiKeys.types";
import CopyIcon from "@common/svgs/copy.svg?react";

export interface IApiKeyCreatedDialogProps {
    result: CreateApiKeyResultViewModel;
    onClose: () => void;
}

function ApiKeyCreatedDialog(props: IApiKeyCreatedDialogProps) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();

    const copy = async () => {
        await navigator.clipboard.writeText(props.result.fullKey);
        snackbar.show(translateString("apiKeyCopied"));
    };

    return (
        <DotLegalDialog
            open
            size="md"
            header={translateString("apiKeyCreatedTitle")}
            buttonOkText={translateString("close")}
            onDialogClose={props.onClose}
            onOkClick={props.onClose}
            hideOkButton={false}
        >
            <Box>
                <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 1 }}>
                    <DotLegalHeader fontWeight={400} center headerStyle="small">
                        {translateString("apiKeyCreatedWarning")}
                    </DotLegalHeader>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                        sx={(theme) => ({
                            flex: 1,
                            border: `1px solid ${theme.palette.grey.A400}`,
                            borderRadius: 1,
                            padding: "7px 14px",
                            fontSize: theme.typography.pxToRem(14),
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            userSelect: "all",
                        })}
                    >
                        {props.result.fullKey}
                    </Box>
                    <IconButton sx={{ marginTop: 0.5 }} onClick={copy} aria-label={translateString("copyApiKey")} title={translateString("copyApiKey")}>
                        <CopyIcon />
                    </IconButton>
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default ApiKeyCreatedDialog;
